import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import ServicesGrid from './components/ServicesGrid';
import AppointmentCTA from './components/AppointmentCTA';
import ResourcesGrid from './components/ResourcesGrid';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <MissionSection />
        <ServicesGrid />
        <AppointmentCTA />
        <ResourcesGrid />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;